import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../utils/firebase";

let cache = null;
let lastFetch = 0;

export async function loadFlags() {
  const now = Date.now();
  if (cache && now - lastFetch < 60_000) return cache;
  const out = {};
  try {
    // Soporta tu esquema: config/app { liteMode: true }
    const appSnap = await getDoc(doc(db, "config", "app"));
    if (appSnap.exists()) {
      const d = appSnap.data();
      if (typeof d.liteMode === "boolean") out.MODO_LITE = d.liteMode;
      // ETIQUETAS_OFF: desactiva impresión de etiquetas y escaneo de entrega
      // (p. ej. cuando la impresora se queda sin tinta). Ver useEtiquetasOff.
      if (typeof d.etiquetasOff === "boolean") out.ETIQUETAS_OFF = d.etiquetasOff;
    }
    // Compatibilidad con el esquema anterior: config/modes { MODO_LITE: true }
    const modesSnap = await getDoc(doc(db, "config", "modes"));
    if (modesSnap.exists()) {
      const d = modesSnap.data();
      if (typeof d.MODO_LITE === "boolean") out.MODO_LITE = d.MODO_LITE;
    }
  } catch (e) {
    console.error("featureFlags load error", e);
  }
  cache = out;
  lastFetch = now;
  return cache;
}

export async function getFlag(name) {
  const flags = await loadFlags();
  if (name in flags) return !!flags[name];
  if (name === "MODO_LITE") {
    return String(import.meta.env.VITE_MODO_LITE || "false") === "true";
  }
  return false;
}

// Activa/desactiva la impresión de etiquetas + escaneo de entrega (flag global
// en config/app.etiquetasOff). Lo usa el Panel de administración.
export async function setEtiquetasOff(value) {
  await setDoc(doc(db, "config", "app"), { etiquetasOff: !!value }, { merge: true });
  cache = null; // invalidar caché para que el próximo getFlag lea lo nuevo
}

// ── Formato de etiqueta ────────────────────────────────────────────────────
// "doble"  = dos etiquetas chicas 7×4 (lo que veníamos usando)
// "unica"  = una etiqueta grande 10×5 (nueva)
// Por defecto "doble" (todavía hay stock de las chicas). Lo elige el admin.
export async function getEtiquetaFormato() {
  try {
    const snap = await getDoc(doc(db, "config", "app"));
    const v = snap.exists() ? snap.data().etiquetaFormato : null;
    return v === "unica" ? "unica" : "doble";
  } catch {
    return "doble";
  }
}

export async function setEtiquetaFormato(value) {
  const v = value === "unica" ? "unica" : "doble";
  await setDoc(doc(db, "config", "app"), { etiquetaFormato: v }, { merge: true });
  cache = null;
}

// ── Delegaciones por licencia ───────────────────────────────────────────────
// On/off manual (config/app.delegaciones). Las activa/desactiva el admin cuando
// alguien se toma licencia:
//   · ventasFactura          → Ventas puede facturar (Administración de licencia)
//   · administracionDespacha → Administración puede despachar (Ventas de licencia)
export async function getDelegaciones() {
  try {
    const snap = await getDoc(doc(db, "config", "app"));
    const d = (snap.exists() && snap.data().delegaciones) || {};
    return {
      ventasFactura: d.ventasFactura === true,
      administracionDespacha: d.administracionDespacha === true,
    };
  } catch {
    return { ventasFactura: false, administracionDespacha: false };
  }
}

// Firestore hace merge recursivo de mapas, así que setear una delegación no pisa
// la otra ni el resto de config/app.
export async function setDelegacion(nombre, value) {
  await setDoc(doc(db, "config", "app"), { delegaciones: { [nombre]: !!value } }, { merge: true });
  cache = null;
}
